import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';

import { BoardCardComponent } from './board-card.component';
import { DynamicHeadingComponent } from './dynamic-heading.component';
import { HomepageModuleRewardModule } from '../homepage-module-reward/homepage-module-reward.module';
import { GenesisPipesModule, GenesisDirectivesModule } from '@genesis-frontend/genesis-utilities';

@NgModule({
    declarations: [BoardCardComponent, DynamicHeadingComponent],
    imports: [CommonModule, HomepageModuleRewardModule, GenesisPipesModule, GenesisDirectivesModule, NgOptimizedImage],
    exports: [BoardCardComponent, DynamicHeadingComponent]
})
export class BoardCardModule { }
